import styled from "styled-components";

export const DownloadButton = styled.button`
  margin: 0 5px;
  background: transparent;
  border: none;
  outline: none;
  cursor: ${({ cursor }) => cursor && cursor};
`;
export const FileImg = styled.img`
  width: 25px;
  height: 25px;
`;
